import { ReactNode } from 'react';
import { useSnapshot } from 'valtio';
import { diagnosticsState } from '../lib/state';
import { DiagnosticsContext } from './DiagnosticsContext';

export const DiagnosticsContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const state = useSnapshot(diagnosticsState);

  return (
    <DiagnosticsContext.Provider value={state}>
      {children}
    </DiagnosticsContext.Provider>
  );
};
